import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { map, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';

import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import { CheckboxFormControlService } from './checkbox-form-control.service';

@Component({
  selector: 'ss-checkbox-form-control',
  templateUrl: './checkbox-form-control.component.html',
  styleUrls: ['./checkbox-form-control.component.css'],
  providers: [
    FormControlService,
    CheckboxFormControlService,
    createControlValueAccessorProvider(CheckboxFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxFormControlComponent extends ControlValueAccessorImpl<boolean> implements OnInit {

  @ViewChild(MatCheckbox)
  private _checkboxRef!: MatCheckbox

  readonly labelObs = this._formControlService.labelObs;
  constructor(
  ) {
    super()
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

    this._checkboxRef
      .change
      .pipe(
        takeUntil(this._destroy),
        map((evParams) => evParams.checked)
      )
      .subscribe((value) => {
        this.valueSubject.next(value)
        this.touchedSubject.next(true)
      })


    this._formControlService.htmlElementSubject.next(this._checkboxRef._elementRef.nativeElement);
  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }

}
